import PropTypes from "prop-types";
import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";

export const EmbedPreview = ({ featuredMediaEmbed, setValue }) => {
  if (!featuredMediaEmbed?.html) return null;
  return (
    <div className="flex items-start">
      <InnerHTML
        className="flex-1 [&>iframe]:aspect-video [&>iframe]:h-auto [&>iframe]:max-w-full"
        html={featuredMediaEmbed.html}
      />
      <Dropdown
        button={
          <div className="text-dark cursor-pointer">
            <Icon type="menu-dots-v2" size={20} />
          </div>
        }
      >
        <Dropdown.ItemWithLink
          onClick={() => setValue("featured_media_embed", null)}
        >
          {t("remove")}
        </Dropdown.ItemWithLink>
      </Dropdown>
    </div>
  );
};

EmbedPreview.propTypes = {
  setValue: PropTypes.func.isRequired,
  featuredMediaEmbed: PropTypes.shape({
    html: PropTypes.string,
  }),
};
